import React, { useContext } from 'react';
import { AgFinancing } from '@indigo-ag/schema';

import { LoadingWrapper, TimelineEventsCard, TimelineEvent, financingBREventTypesTranslations, UserUtil } from 'shared';
import { getAllFinancingEventsForGrower } from '../../queries';

import { FinanceProcessContext } from 'features/brazil-grower/pages/BrazilGrowersDetail';

export const NegotiationTimelineEvents: React.FunctionComponent = () => {
  /**
   * Finance Process Context
   */
  const { agFinancingId } = useContext(FinanceProcessContext);

  return (
    <div className="flex" style={{ flexWrap: 'wrap' }}>
      <div style={{ minWidth: '212px', marginBottom: '0', flexGrow: 1, flexShrink: 1, flexBasis: '0', marginLeft: 15 }}>
        <LoadingWrapper query={getAllFinancingEventsForGrower} queryOptions={{ variables: { agFinancingId } }}>
          {({ data }: { data: { financingAgFinancing: AgFinancing } }) => {
            const events: TimelineEvent[] =
              data?.financingAgFinancing?.allEvents?.map(e => ({
                createdBy: UserUtil.getUserFullName(e.createdBy),
                createdAt: e.createdAt,
                mainText: financingBREventTypesTranslations[e.eventType],
                notes: e.text
              })) || [];

            return <TimelineEventsCard events={events} maxHeight="55vh" />;
          }}
        </LoadingWrapper>
      </div>
    </div>
  );
};
